// Types
// Hooks
import useUserRole from '@/utils/hooks/user/useUserRole';

import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const DowngradeEffective = ({ notification }: NotificationSubscriptionProps) => {
    const { isAdmin } = useUserRole();
    return (
        <Notification
            dataNotification={notification}
            goToUrl={isAdmin ? SUBSCRIPTION_INVOICES : null}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title
                    i18nKey="commons:notifications.downgrade_being_effective.title"
                    values={{ plan_name: notification?.data?.plan_name }}
                />
                {isAdmin ? (
                    <Notification.Description i18nKey="commons:notifications.downgrade_being_effective.description" />
                ) : null}
            </Notification.Content>
        </Notification>
    );
};

export default DowngradeEffective;
